(function () {
    "use strict";

    angular
        .module("app")
        .component("header3", { // header
            templateUrl: "src/app/_shared/header/header3.html",
            controller: controller
        });

    function controller($scope, $http, $location, $window, $analytics, session, loginModal, CART_TYPE_CODE) {
        const $ctrl = this;
        $ctrl.loginUrl = "/login?redirectTo=" + encodeURI($location.path());
        $ctrl.session = session;
        $ctrl.CART_TYPE_CODE = CART_TYPE_CODE;
        $ctrl.customer = session.customer;
        $ctrl.searchText = "";
        $ctrl.showLogo = false;
        $ctrl.hideHeader = $location.$$path.indexOf("shipping-label") >= 0;

        $scope.$watch(() => session.customer, customer => {
            if (!customer) {
                $ctrl.showLogo = false;
                $ctrl.logoSrc = "/dist/images/logo.png";
            } else {
                $ctrl.customer = session.customer;
                $http.get(`/api/images/customer/${customer.customer_id}/small?default=false`,
                        { responseType: 'arraybuffer' })
                    .then(result => {
                        $ctrl.showLogo = true;
                        const blob = new Blob([result.data], { type: "imageType" });
                        $ctrl.logoSrc = window.URL.createObjectURL(blob);
                    })
                    .catch(() => {
                        $ctrl.showLogo = false;
                        $ctrl.logoSrc = "/dist/images/logo.png";
                    });
            }
        });

        $scope.$watch(() => session.products.searchCriteria.searchText, newSearchText => {
            if (!newSearchText || newSearchText.length == 0) {
                $ctrl.searchText = "";
            }
        });

        $ctrl.$onInit = () => {
            //session.refresh(true);
        };

        $ctrl.cartTypeName = () => {
            if (session.cartTypeCode === CART_TYPE_CODE.CSOS)
                return "CONTROLLED SUBSTANCES";
            else if (session.cartTypeCode === CART_TYPE_CODE.RX)
                return "RX PRODUCTS";
            else
                return "";
        };

        $ctrl.login = () => {
            loginModal();
        };

        $ctrl.logOut = () => {
            const isSaml = session.customer.is_saml;
            const sloUrl = session.customer.slo_url;
            const path = isSaml ? sloUrl : "/";

            session.logOut().then(() => {
                $window.location.href = path;
            });
        };

        $ctrl.logoClicked = () => {
            $location.path("/");
        };

        $ctrl.killSearchKeyUp = false;
        $ctrl.search = () => {
            $ctrl.killSearchKeyUp = true;
            $analytics.eventTrack("Click", { category: "Search", label: session.products.searchCriteria.searchText });
            session.products.searchCriteria.cs = false;
            session.products.searchCriteria.classId = null;
            //session.products.searchCriteria.searchText = $ctrl.searchText;
            //session.gotoProductSearch();
            const path = `/products/all/`;
            $location.path(path);
        }

        $ctrl.customerSelected = (customer) => {
            session
                .setCartType(CART_TYPE_CODE.RX)
                .then(() => session.setCustomer(customer))
                .then(() => {
                    $ctrl.search();
                });
        };

        $ctrl.cartSelected = cartTypeCode => {
            session
                .setCartType(cartTypeCode)
                .then(() => {
                    session.gotoCart();
                });
        };

        $ctrl.productSelected = cartTypeCode => {
            session
                .setCartType(cartTypeCode)
                .then(() => {
                    $ctrl.search();
                });
        };

        
        $ctrl.searchKeyUp = $event => {
            if ($event.keyCode === 13 && !$ctrl.killSearchKeyUp) {
                $ctrl.search();
            } else {
                $ctrl.killSearchKeyUp = false;
            }
        };
    }
    controller.$inject = ["$scope", "$http", "$location", "$window","$analytics", "sessionService", "loginModal", "CART_TYPE_CODE"];

})()